var map = {
	"./Bcone.png": "f006",
	"./Emerd.png": "5279",
	"./Fast.png": "f965",
	"./Sapre.png": "8c0e",
	"./isauto.png": "7259",
	"./retreat.png": "0ae8",
	"./unwinning-zh.png": "bcc2",
	"./unwinning.png": "4692",
	"./winning-zh.png": "76ee",
	"./winning.png": "06a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5c35";